import React from 'react'
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import moment from 'moment';
// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Grid,
  Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { connect } from 'react-redux';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import { ListHead, ListToolbar, MoreMenu, DatePicker } from '../components/_dashboard/car';
import { addCarDetail, fetchAllCarDetails, searchCars } from '../actions/carDetailsAction';
import _ from 'lodash';
import { resetState } from '../actions/resetAction';
import { RESET } from "../actions/types";
import ModalCompoennt from './Portal/ModalCompoennt';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import UpdateCarDetail from './cardetails/UpdateCarDetail';
import CreateProformaInvoice from './proformainvoices/CreateProformaInvoice';
import CreateAgreement from './agreements/CreateAgreement';
import CreateReProcessing from './reprocessing/CreateReProcessing';
import DeleteCarDetail from './cardetails/DeleteCarDetail';
import ViewCarDetails from './cardetails/ViewCarDetails';
import Pagination from '@mui/material/Pagination';
import SearchIcon from '@mui/icons-material/Search';
import ResetIcon from '@mui/icons-material/Restore';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Buyer Name', alignRight: false },
  { id: 'id_no', label: 'Id No', alignRight: false },
  { id: 'telephone', label: 'Telephone', alignRight: false },
  { id: 'model', label: 'Model', alignRight: false },
  { id: 'motor', label: 'Motor', alignRight: false },
  { id: 'chasis no', label: 'Chasis No', alignRight: false },
  { id: 'reg no', label: 'Reg No', alignRight: false },
  { id: 'agreed price', label: 'Agreed Price', alignRight: false },
  { id: 'action', label: 'Actions', alignRight: false },
  { id: '', label: '', alignRight: false },
];

// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "70%",
  height:"90%",
  bgcolor: 'background.paper',
  boxShadow: 50,
  border:"none"
};

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
  },
  '&.css-1s2atx1-MuiButtonBase-root-MuiIconButton-root':{
    padding:0
  }
}));


function DashboardApp(props) {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState([]);
  const [filterBuyerName, setFilterBuyerName] = useState('');
  const [filterIdNo, setFilterIdNo] = useState('');
  const [filterModel, setFilterModel] = useState('');
  const [filterMotor, setFilterMotor] = useState('');
  const [filterChasisNo, setFilterChasisNo] = useState('');
  const [filterRegNo, setFilterRegNo] = useState('');
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openCarDetails, setOpenCarDetails] = useState(false);
  const [carObj, setCarObj] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [openProformaInvoice, setOpenProformaInvoice] = useState(false);
  const [openAgreement, setOpenAgreement] = useState(false);
  const [openReProcessingForm, setopenReProcessingForm] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    props.fetchAllCarDetails(page);
    return () => {
      props.resetState(RESET);
    };
  },[]);

  const handleCreateButtonClick = () => {
    navigate('/dashboard/add/car', { replace: true });
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = props.users.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleUpdateClick = (car) => {
    setOpenUpdate(true);
    setCarObj(car);
  }

  const closeButton = () => {
    setOpenUpdate(false);
    setOpenProformaInvoice(false);
    setOpenAgreement(false);
    setopenReProcessingForm(false);
    setOpenDelete(false);
    setOpenCarDetails(false);
    setCarObj({});
  }

  const handleFilterByBuyerName = (event) => {
    setFilterBuyerName(event.target.value);
  };

  const handleFilterByIdNo = (event) => {
    setFilterIdNo(event.target.value);
  };

  const handleFilterByModel = (event) => {
    setFilterModel(event.target.value);
  };

  const handleFilterByMotor = (event) => {
    setFilterMotor(event.target.value);
  };

  const handleFilterByChasisNo = (event) => {
    setFilterChasisNo(event.target.value);
  };

  const handleFilterByRegNo = (event) => {
    setFilterRegNo(event.target.value);
  };

  const handleOpenInvoice = (car) => {
    setCarObj({carObj:car});
    setOpenProformaInvoice(true);
  }

  const handleOpenAgreement = (car) => {
    setCarObj({carObj:car});
    setOpenAgreement(true);
  }

  const handleOpenReProcessingForm = (car) => {
    setCarObj({carObj:car});
    setopenReProcessingForm(true);
  }

  const hanldeDeleteClick = (car) => {
    setOpenDelete(true);
    setCarObj({carObj:car});
  }

  const handleCarDetail = (car) => {
    setCarObj({carObj:car});
    setOpenCarDetails(true);
  }

  const renderCarList = () => {
    if(!_.isEmpty(props.carDetails.data)) {
      var cars = props.carDetails.data;
      var f_cars = _.orderBy(cars, ['id'], ['desc']);
      return f_cars.map((car) => {
        return (
          <TableRow
            hover 
            tabIndex={-1}
          >
            <TableCell align="left" style={{padding:"10px"}}>{car.buyer_name}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.id_no}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.telephone}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.model}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.motor}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.chasis_no}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.reg_no}</TableCell>
            <TableCell align="left" style={{padding:"10px"}}>{car.agreed_price}</TableCell>
            <TableCell align="left" style={{padding:"10px",display:"flex",border:'0px',marginTop:"15px"}}>
              <IconButton onClick={() => handleUpdateClick(car)} sx={{float:"left",padding:"0px", color:"#c29136"}}>
                <Edit />
              </IconButton>
              <IconButton sx={{float:"left",padding:"0px", color:"red"}} onClick={() => hanldeDeleteClick(car)}>
                <DeleteOutlined />
              </IconButton>
            </TableCell>
            <TableCell align="left" style={{padding:"10px"}}>
              <MoreMenu car={car} isAgreementMenu={false} isCarMenu={true} handleOpenInvoice={() => handleOpenInvoice(car)} handleOpenAgreement={() => handleOpenAgreement(car)} handleOpenReProcessingForm={() => handleOpenReProcessingForm(car)} handleOpenInstallmentPlan={() => handleOpenInstallmentPlan(car)} handleCarDetail={() => handleCarDetail(car)} />
            </TableCell>
          </TableRow>
        );
      });
    } else {
      return <TableRow>
        <TableCell colSpan={10} >No Car Found</TableCell>
      </TableRow>
    }
  }

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    props.fetchAllCarDetails(newPage)
  }

  const searchRecord = () => {
    if(filterBuyerName != '' || filterIdNo != '' || filterModel != '' || filterMotor != '' || filterChasisNo != '' || filterRegNo != "") {
      const values = {
        buyer_name: filterBuyerName,
        id_no: filterIdNo,
        model: filterModel,
        motor: filterMotor,
        chasis_no: filterChasisNo,
        reg_no: filterRegNo,
      };
      props.searchCars(values);
    } else {
      console.log('insert record');
    }
  }

  const handleReset = () => {
    setFilterBuyerName('');
    setFilterIdNo('');
    setFilterModel('');
    setFilterMotor('');
    setFilterChasisNo('');
    setFilterRegNo('');
    props.fetchAllCarDetails(page);
  }

  return (
    <Page title="Car List">
      <Container maxWidth="100%">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Grid>
            <Typography variant="h4" gutterBottom>
              Car List 
            </Typography>
          </Grid>
          <Grid>
            <Button
              fullWidth
              size="medium"
              type="submit"
              variant="contained"
              loading={isLoading}
              sx={{backgroundColor: '#c29136',}}
              onClick={() => handleCreateButtonClick()}
            >
              Add Car
            </Button>
          </Grid>
        </Stack>

        <Card>
          <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead
                  headLabel={TABLE_HEAD}
                  rowCount={props.carDetails.length}
                  numSelected={selected.length}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableRow>
                  <TableCell align="left" style={{padding:"0px"}} colSpan={2}>
                    <ListToolbar
                      // numSelected={selected.length}
                      filter={filterBuyerName}
                      onFilter={handleFilterByBuyerName}
                      filterPlaceHolder= "Buyer Name..."
                    />
                  </TableCell>
                  <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                    <ListToolbar
                      // numSelected={selected.length}
                      filter={filterIdNo}
                      onFilter={handleFilterByIdNo}
                      filterPlaceHolder= "Id No..."
                    />
                  </TableCell>
                  <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                    <ListToolbar
                      // numSelected={selected.length}
                      filter={filterModel}
                      onFilter={handleFilterByModel}
                      filterPlaceHolder= "Model..."
                    />
                  </TableCell>
                  <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                    <ListToolbar
                      // numSelected={selected.length}
                      filter={filterMotor}
                      onFilter={handleFilterByMotor}
                      filterPlaceHolder= "Motor..."
                    />
                  </TableCell>
                  <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                    <ListToolbar
                      // numSelected={selected.length}
                      filter={filterChasisNo}
                      onFilter={handleFilterByChasisNo}
                      filterPlaceHolder= "Chasis No..."
                    />
                  </TableCell>
                  <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                    <ListToolbar
                      // numSelected={selected.length}
                      filter={filterRegNo}
                      onFilter={handleFilterByRegNo}
                      filterPlaceHolder= "Reg No..."
                    />
                  </TableCell>
                  <TableCell colSpan={1}>
                    <Button variant="contained" onClick={searchRecord} sx={{backgroundColor:"#c29136"}} startIcon={<SearchIcon />}>Search</Button>
                  </TableCell>
                  <TableCell colSpan={2}>
                    <Button variant="contained" onClick={handleReset} sx={{backgroundColor:"red"}} startIcon={<ResetIcon />} >Reset</Button>
                  </TableCell>
                </TableRow>
                <TableBody>
                  {renderCarList()}
                </TableBody>
              </Table>
              <Pagination sx={{float:"right",marginTop:"10px",marginBottom:"10px"}} page={page} count={props.carDetails.paginate.last_page} variant="outlined" color="primary" onChange={handlePageChange} />
            </TableContainer>
          </Scrollbar>
        </Card> 
      </Container>
      {
        openUpdate && 
        <ModalCompoennt open={openUpdate} onClose={closeButton} title="Update Car Detail" width="lg">
            <UpdateCarDetail car={carObj} onDismis={closeButton} />
        </ModalCompoennt>
      }
      {
        openProformaInvoice && 
          <ModalCompoennt open={openProformaInvoice} onClose={closeButton} title="Create Proforma Invoice" width="md">
            <CreateProformaInvoice carObj={carObj} onDismis={closeButton} />
          </ModalCompoennt>
      }
      {
        openAgreement && 
          <ModalCompoennt open={openAgreement} onClose={closeButton} title="Create Agreement" width="lg">
            <CreateAgreement carObj={carObj} onDismis={closeButton} />
          </ModalCompoennt>
      }
      {
        openReProcessingForm && 
          <ModalCompoennt open={openReProcessingForm} onClose={closeButton} title="Create Re Processing" width="lg">
            <CreateReProcessing carObj={carObj} onDismis={closeButton} />
          </ModalCompoennt>
      }
      {
        openDelete &&
        <ModalCompoennt open={openDelete} onClose={closeButton} title="Delete" width="xs" color="red">
          <DeleteCarDetail carObj={carObj} onDismis={closeButton} />
        </ModalCompoennt>
      }
      {
        openCarDetails &&
        <ModalCompoennt open={openCarDetails} onClose={closeButton} title={`${carObj.carObj.motor} Details`} width="lg">
          <ViewCarDetails carObj={carObj} onDismis={closeButton} />
        </ModalCompoennt>
      }
    </Page>
  );
}

const mapStateToProps = state => {
  return {
    carDetails:state.carDetailList,
  }
}

export default connect(mapStateToProps, { fetchAllCarDetails, addCarDetail, resetState, searchCars })(DashboardApp);